/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto } from '../models/Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DeleteAwardService {

    /**
     * @param awardIds
     * @returns Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppDeleteAwardRsuAwards(
        awardIds?: Array<string>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/delete-award/rsu-awards',
            query: {
                'awardIds': awardIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardIds
     * @returns Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppDeleteAwardPsuAwards(
        awardIds?: Array<string>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/delete-award/psu-awards',
            query: {
                'awardIds': awardIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardIds
     * @returns Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppDeleteAwardOptionAwards(
        awardIds?: Array<string>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/delete-award/option-awards',
            query: {
                'awardIds': awardIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
